import { IConfigSeller } from '@/models/configSeller'
import ReceiptExample from '@/assets/images/boleta_ejemplo.png'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Tooltip } from '@nextui-org/react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { TiDocumentAdd } from 'react-icons/ti'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IAppStore } from '../../../../models/store.model'
import { webApiService } from '../../../../services'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useTradeinContext } from '../hooks/useTradeinContext'

const AddDocument = () => {
  const [data, setData] = useState<{ open: boolean, loading: boolean, documento: string, listCR: any[] }>({ open: false, loading: false, documento: '', listCR: [] })
  const { slug } = useParams()
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'

  const hasDocument = ctx.tradein.document_cupon_used !== null && ctx.tradein.document_cupon_used !== undefined && ctx.tradein.document_cupon_used !== ''
  const title = hasDocument ? 'Actualizar Documento' : 'Agregar Documento'

  const handleOpen = () => {
    setData({ ...data, open: true, documento: ctx.tradein.document_cupon_used ?? '' })
  }

  const handleClose = () => {
    setData({ ...data, open: false, loading: false, documento: '' })
  }

  const saveDocument = (documento: string, successMessage: string) => {
    setData({ ...data, loading: true })
    webApiService.updateDocument({ id_tradein: Number(ctx.tradein.id), id_user: userState.id, document_cupon_used: documento, seller: slug }).then(() => {
      enqueueSnackbar(successMessage, { variant: 'success' })
      setData({ ...data, loading: false, documento: '', open: false })
      saveCtx({ ...ctx, reload: true })
    }).catch((error) => {
      enqueueSnackbar('Hubo un error al guardar el documento', { variant: 'error' })
      setData({ ...data, loading: false })
      console.log('error ==>', error)
    })
  }

  const handleSave = () => saveDocument(data.documento.trim(), hasDocument ? 'Documento actualizado correctamente' : 'Documento agregado correctamente')

  return (
    <div>
      <Button
        size='sm'
        legacyColor='success'
        legacyVariant='shadow'
        onClick={handleOpen}
      >
        <TiDocumentAdd />
        {title}
      </Button>

      <Modal backdrop='blur' isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>{title}</ModalHeader>
          {isWom && (
            <div className='absolute top-3 right-12 z-10'>
              <Tooltip
                placement='bottom-end'
                content={
                  <div className='p-2 flex flex-col items-center gap-2'>
                    <span className='font-bold'>Ejemplo de boleta</span>
                    <img src={ReceiptExample} alt='Ejemplo de boleta' className='w-[600px] max-w-[80vw] rounded' />
                  </div>
                }
              >
                <span className='cursor-pointer text-xl text-default-500'><AiOutlineInfoCircle /></span>
              </Tooltip>
            </div>
          )}
          <ModalBody>
            <h4 className='text-lg mb-2 font-black'>{isWom ? 'Ingrese el número de boleta/factura en donde se utilizó el cupón que generó el trade-in.' : 'Ingrese el documento (No. ticket de compra) donde se utulizó el cupón que genero el trade-in '}</h4>
            <Input
              value={data.documento}
              onChange={(e) => { setData({ ...data, documento: e.target.value }) }}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant='destructive'
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button type='submit' disabled={data.documento.trim() === '' || data.documento.trim() === ctx.tradein.document_cupon_used || data.loading} onClick={handleSave}>
              {data.loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default AddDocument
